const IconCancel = ({ className }) => {
    return (
        <svg
            width='36'
            height='36'
            viewBox='0 0 36 36'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className={className}
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M18 6C11.3726 6 6 11.3726 6 18C6 24.6274 11.3726 30 18 30C24.6274 30 30 24.6274 30 18C30 11.3726 24.6274 6 18 6ZM3 18C3 9.71573 9.71573 3 18 3C26.2843 3 33 9.71573 33 18C33 26.2843 26.2843 33 18 33C9.71573 33 3 26.2843 3 18ZM13.9393 13.9393C14.5251 13.3536 15.4749 13.3536 16.0607 13.9393L18 15.8787L19.9393 13.9393C20.5251 13.3536 21.4749 13.3536 22.0607 13.9393C22.6464 14.5251 22.6464 15.4749 22.0607 16.0607L20.1213 18L22.0607 19.9393C22.6464 20.5251 22.6464 21.4749 22.0607 22.0607C21.4749 22.6464 20.5251 22.6464 19.9393 22.0607L18 20.1213L16.0607 22.0607C15.4749 22.6464 14.5251 22.6464 13.9393 22.0607C13.3536 21.4749 13.3536 20.5251 13.9393 19.9393L15.8787 18L13.9393 16.0607C13.3536 15.4749 13.3536 14.5251 13.9393 13.9393Z'
            />
        </svg>
    );
};

export default IconCancel;
